<template>
  <div class="navContextMenuSharedWrapper">
    <nuxt-link to="/parameter/" class="navBaseElem paddedElem">
      <span class="text">{{ $t("layout.menu.menu02") }}</span>
    </nuxt-link>
    <a
      :href="`https://help.groover.co/${lang}/`"
      class="navBaseElem paddedElem"
      target="_blank"
    >
      <span class="text">{{ $t("layout.menu.menu03") }}</span>
    </a>
    <div
      v-if="accounts.length"
      class="navBaseElem paddedElem"
      @click.stop="$emit('display_acc_swap')"
    >
      <div class="flexWrap">
        <span class="text">{{ $t("layout.menu.menu04") }}</span>
        <i class="icon fas fa-chevron-right" />
      </div>
    </div>
    <div
      v-else
      class="navBaseElem paddedElem"
      @click="$emit('login_request_account_swap')"
    >
      <span class="text">{{ $t("auth.accountSwitch00") }}</span>
    </div>
    <div class="navBaseElem paddedElem logout" @click="$emit('logout')">
      <span class="text">{{ $t("layout.menu.menu05") }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      lang: (state) => state.user.lang,
      accounts: (state) => state.accounts,
    }),
  },
}
</script>

<style scoped src="~/components/nav/loggedIn/navBaseElem.css"></style>
<style scoped>
.text {
  color: var(--color-black);
  font-size: var(--font-size-small);
  font-weight: 500;
}

.icon {
  color: var(--color-darker-grey);
  font-size: var(--font-size-eleven);
}

.flexWrap {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navBaseElem.logout {
  margin-bottom: 8px;
}
</style>
